# JavaScript provided by RubyGems.
#
#= require jquery.min
#= require jquery_ujs
#= require onload
#= require js-routes
#= require highcharts-8.2.2/highcharts
#= require i18n
#= require i18n/translations
#= require select2
#= require ace/ace
#= require ace/mode-perl
#= require ace/mode-php
#= require ace/mode-ruby
#= require ace/mode-javascript
#= require ace/mode-sql
#= require ace/theme-xcode
#= require ace/jquery-ace
#= require moment
#= require daterangepicker
#
# Vendored JavaScript files.
#
#= require modernizr-2.6.2.min
#= require base64
#= require jQuery.XDomainRequest
#= require bootstrap
#= require bootstrap-datepicker
#= require underscore
#= require jquery.nav
#= require jquery.scrollTo
#= require jquery.stickem
#= require jquery.hoverIntent
#= require jquery.ocupload
#= require strftime
#= require v.application
#= require purl
#= require spin
#= require jquery.menu-aim
#= require highlight.pack
#= require FileAPI.min
#= require zero-clipboard
#
# Libraries.
#
# Application files.
#
#= require_self
#
#= require_tree ./concerns
#= require_tree ./subscribers
#= require_tree ./web_forms
#
#= require application
#= require attachments
#= require autoresponders
#= require campaigns
#= require custom_fields
#= require organizations
#= require seed_lists
#= require segmentation_criterias
#= require special_sending_rules
#= require statistics
#= require subscriber_exports
#= require subscriber_imports
#= require subscription_web_forms
#= require suppressed_address_imports
#= require suppressed_addresses
#= require suppression_lists
#= require users

$.ajaxSetup cache: false

Highcharts.setOptions
  global:
    useUTC: true
  colors: [ '#a53817', '#3c4349', '#db6c1b', '#afb93c', '#f7dc4d' ]
  credits:
    enabled: false
  chart:
    backgroundColor: 'transparent'

window.t = (scope, options) ->
  text = I18n.translate(scope, options)
  if text.replace
    text
      .replace(/\$\$greenarrow_engine\$\$/g, window.studioSystemName || "GreenArrow Engine")
      .replace(/\$\$greenarrow_studio\$\$/g, window.studioSystemName || "GreenArrow Studio")
      .replace(/\$\$greenarrow_\$\$/g      , window.studioSystemName || "GreenArrow"       )
  else
    text

window.Concerns = {}

RegExp.escape = (s) => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')

# jQuery 4 fetches dataType-"script" requests (jquery_ujs remote links/forms,
# the Paginator's $.getScript) by injecting a <script> tag. That request sends
# Accept: */*, so Rails negotiates the HTML format, and the browser's strict
# MIME checking then refuses to execute the text/html response. Setting any
# request header forces jQuery back onto the XHR transport, which sends the
# JavaScript Accept header (Rails responds with the .js template) and executes
# the response with globalEval — the pre-jQuery-4 behavior this app relies on.
$.ajaxPrefilter "script", (s) -> s.headers ||= { "X-Requested-With": "XMLHttpRequest" }

$ ->

  $('body').on "click", "a[data-confirm-destroy]", ->
    Dialogs.presentRemovalModal \
      $(@).attr("data-confirm-question"),
      $(@).attr("data-confirm-destroy"),
      $(@).attr("data-confirm-destroy-type"),
      => $.rails.handleMethod $(@)

    return false

  $('body').on "click", "a[data-modal-body]", ->
    Dialogs.presentModal
      body: $(@).data('modal-body')

    return false


  $('body').on "click", "a[data-yesno]", ->
    Dialogs.presentYesNoModal \
      $(@).attr("data-yesno"),
      {},
      $(@).attr("href")

    return false

  $(".html-content-preview").each -> HtmlContentPreview.setup $(@)

  $("a[data-alert-and-stop]").on "click", (e) ->
    Dialogs.presentAlertModal($(@).attr("data-alert-and-stop"))
    e.preventDefault()

  Paginator.setup 'select.per-page-controller'

  UI.setupDatepickers()
  UI.setupSelects()
  UI.setupLinks()
  UI.setupDisablingPills()

  FormSectionDisabler.setup 'a.form-section-disabler'

  $(".permitted_email_address_container").each ->
    new PermittedEmailInput(@)

  YesNoFieldToggler.setup()

  $(".link-to-reveal").on "click", (e) ->
    $old = $(@)
    $new = $("<div></div>")
    $new.text($old.data("reveal"))
    $old.replaceWith($new)
    e.preventDefault()

  ContentImporter.setup()
